import classnames from 'classnames'
import {Browser} from '@clappr/core'
import styles from './styles.scss'

const rootClassName = classnames(
  styles.root,
  !Browser.isMobile && styles.withArrows
)

const itemsListAttributes = Browser.isMobile
  ? 'data-suggest-scroll-items'
  : 'data-suggest-slider-items'

const arrows = Browser.isMobile
  ? `<div class="${styles.arrow} ${styles.leftArrow}" data-suggest-prev></div>
<div class="${styles.arrow} ${styles.rightArrow}" data-suggest-next></div>`
  : `<div class="${styles.arrow} ${styles.leftArrow}" data-suggest-prev>
<svg class="${styles.arrowIcon}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <path d="M0 20V0m20 0v20m-7.88-3.82L6.65 10.7a1 1 0 0 1 0-1.42l5.47-5.47a.5.5 0 0 1 .7 0l.36.36a.5.5 0 0 1 0 .7L8.06 10l5.12 5.12a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0"/>
</svg>
</div>
<div class="${styles.arrow} ${styles.rightArrow}" data-suggest-next>
<svg class="${styles.arrowIcon}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <path d="M0 20V0m20 0v20M7.18 16.18l-.36-.36a.5.5 0 0 1 0-.7L11.94 10 6.82 4.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5.47 5.47a1 1 0 0 1 0 1.42l-5.47 5.47a.5.5 0 0 1-.7 0"/>
</svg>
</div>`

export default `<div class="${rootClassName}">
  <div class="${styles.replay} ${styles.button}" data-suggest-replay>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        fill-rule="evenodd"
        d="M0 20V0m20 20V0M4.62 8.81a5.51 5.51 0 0 0 4.9 6.67.5.5 0 0 1 .48.5v.5a.5.5 0 0 1-.52.5A7 7 0 0 1 10 3c2.3 0 4.33 1.12 5.6 2.84V3.5a.5.5 0 0 1 .5-.5h.4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.4a.5.5 0 0 1 .5-.5h1.8a5.48 5.48 0 0 0-5.36-2 5.5 5.5 0 0 0-4.31 4.21"
      />
    </svg>
  </div>
  <div class="${styles.content}">
    <div class="${styles.title}">
      Рекомендации к просмотру
    </div>
    <div class="${styles.close} ${styles.button}" data-suggest-close>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M0 20V0m20 0v20M16.18 4.88 11.06 10l5.12 5.12a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0L10 11.06l-5.12 5.12a.5.5 0 0 1-.7 0l-.36-.36a.5.5 0 0 1 0-.7L8.94 10 3.82 4.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0L10 8.94l5.12-5.12a.5.5 0 0 1 .7 0l.36.36a.5.5 0 0 1 0 .7"
        />
      </svg>
    </div>
    <div class="${styles.slider}" data-suggest-slider>
      <div class="${styles.list}" ${itemsListAttributes}>
        <% records.forEach(function (record) { %>
        <div class="${styles.item}" data-id="<%= record.id %>" data-url="<%- record.click_url %>">
          <div class="${styles.itemThumbnail}">
            <img class="${styles.itemImage}" src="<%- record.current_screenshot_small %>" />
            <div class="${styles.itemDuration}"><%- record.duration %></div>
          </div>
          <div class="${styles.itemCaption}"><%- record.name %></div>
        </div>
        <% }) %>
      </div>
      ${arrows}
    </div>
  </div>
</div>`
